// export const BASE_URL_API = "https://cors-anywhere.herokuapp.com/https://ca.qnnox.com/web/apis"
export const BASE_URL_API = "https://ca.qnnox.com/web/apis"